export enum LogLevel {
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
  DEBUG = 'debug',
  CRITICAL = 'critical',
  SUCCESS = 'success',
}

export enum LogCategory {
  AUTH = 'AUTH',
  API = 'API',
  DATA = 'DATA',
  GENERAL = 'GENERAL',
  NAVIGATION = 'NAVIGATION',
  ONBOARDING = 'ONBOARDING',
  PROFILE = 'PROFILE',
  SECURITY = 'SECURITY',
  LEAD_MANAGEMENT = 'LEAD_MANAGEMENT',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  SYSTEM = 'SYSTEM',
  EVENT = 'EVENT',
  EVENT_TICKET = 'EVENT_TICKET',
  GRAPH = 'GRAPH',
  EMAIL = 'EMAIL',
  GIG = 'GIG',
  SPONSOR = 'SPONSOR',
  SUPPORT = 'SUPPORT',
  VENUE = 'VENUE',
  DAO = 'DAO',
  ARTIST = 'ARTIST',
}

export interface Log {
  id: string;
  userId?: string;
  message: string;
  timestamp: number;
  level: LogLevel;
  category: LogCategory;
  data?: Record<string, unknown>;
}
